export const InitialState = {
  firstTimeRedirect: {
    atomName: '',
    number: 0,
  },
}
